import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, requiredRole }) {
  const { isLoggedIn, user } = useAuth();

  if (!isLoggedIn) {
    // Si l'utilisateur n'est pas connecté, le rediriger vers la page d'authentification
    return <Navigate to="/auth" replace />;
  }

  // Si un rôle est requis et que l'utilisateur n'a pas ce rôle, le rediriger
  if (requiredRole && user?.role !== requiredRole) {
    // Rediriger vers la page de compte pour les utilisateurs standards, ou l'accueil par défaut
    return <Navigate to="/mon-compte" replace />;
  }

  // Si l'utilisateur est connecté et a le bon rôle (si requis), afficher le contenu
  return children;
}

export default ProtectedRoute;
